import { useEffect } from 'react';
import { useIdleTimer } from 'react-idle-timer';
import { IFRAME_SERVICE_RESET_IDLE_MESSAGE_ID, IFrameMessageService } from '@philips-internal/oswald-ui-components';
function IdleTimer(props) {
    const idleTimerInstance = useIdleTimer({
        ...props,
    });
    useEffect(() => {
        const unsubscribe = IFrameMessageService.subscribe(IFRAME_SERVICE_RESET_IDLE_MESSAGE_ID, () => idleTimerInstance.reset());
        return () => {
            unsubscribe();
        };
    }, [idleTimerInstance]);
    return null;
}
export { IdleTimer, };
//# sourceMappingURL=idle-timer.js.map